import styled from "styled-components";

export const StyledButton = styled("button") <{ color?: string }>`
  background: ${(p) => p.color || "#2e186a"};
  color: ${(p) => (p.color ? "#2E186A" : "#fff")};
  font-size: 1rem;
  font-weight: 700;
  width: 100%;
  border: 1px solid #edf3f5;
  border-radius: 15px;
  padding: 13px 0;
  cursor: pointer;
  margin-top: 0.625rem;
  max-width: 180px;
  transition: all 0.3s ease-in-out;
  box-shadow: 0 16px 30px rgb(23 31 114 / 20%);

  &:hover,
  &:active,
  &:focus {
    color: #fff;
    border: 1px solid rgb(255, 130, 92);
    background-color: rgb(255, 130, 92);
  }
`;

export const StyledPhoneBox = styled("button") <{ color?: string }>`
  background: ${(p) => p.color || "#2e186a"};
  color: ${(p) => (p.color ? "#2E186A" : "#fff")};
  font-size: 1rem;
  font-weight: 700;
  width: 100%;
  border: 1px solid #edf3f5;
  border-radius: 15px;
  padding: 13px 0;
  cursor: default; /* Ensures the cursor does not change to a pointer */
  margin: 0.625rem;
  max-width: 180px;
  transition: all 0.3s ease-in-out;
  box-shadow: 0 16px 30px rgb(23 31 114 / 20%);
  pointer-events: none; /* Makes the button unclickable */

  /* Remove hover, active, and focus styles */
  &:hover,
  &:active,
  &:focus {
    color: ${(p) => (p.color ? "#2E186A" : "#fff")};
    border: 1px solid #edf3f5;
    background-color: ${(p) => p.color || "#2e186a"};
  }
`;
